import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CourseVersion } from '@scaffold/services/version-control.service';

@Component({
  selector: 'app-version-form',
  templateUrl: './version-form.component.html',
  styleUrls: ['../version-control.component.scss'],
  standalone: false,
})
export class VersionFormComponent implements OnInit {
  @Input() version: CourseVersion;
  @Output() versionChange = new EventEmitter<CourseVersion>();

  editor_options = {
    inline: true,
    mode: 'exact',
    branding: false,
    browser_spellcheck: true,
    plugins: [
      'advlist lists charmap link',
      'searchreplace wordcount visualblocks visualchars nonbreaking noneditable',
      'image autoresize textcolor table code paste, template' /* BeyondGrammar"*/,
    ],
    advlist_bullet_styles: 'default,circle,disc,square,none',
    paste_auto_cleanup_on_paste: true,
    paste_retain_style_properties:
      'background background-color color font-size',
    allow_script_urls: true,
    remove_script_host: false,
    minHeight: 50,
    convert_urls: false,
    skin: 'lightgray',
    schema: 'html5',
    removed_menuitems: 'copy cut paste',
    toolbar:
      'undo redo | link | styleselect | bold italic | alignmenu | bindent | bullist numlist listindent listoutdent | forecolor backcolor | BeyondGrammar',
    statusbar: true,
    custom_elements:
      'math,maction,maligngroup,malignmark,menclose,merror,mfenced,mfrac,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msup,msubsup,mtable,mtd,mtext,mtr,munder,munderover,semantics,annotation,annotation-xml,mathvariant,mathsize,mathcolor,mathbackground',
    valid_children: '+span[math],+p[math],+code[ol]',
    extended_valid_elements:
      '@[itemscope|itemtype|itemid|itemprop|content|artifacttype],embed[flashvars|width|height|src|class|id|type],a[onclick|href|name|target|rel|title|class|style|id|download|hreflang|media|type],' +
      'mo[*],mover[*],munderover[*],munder[*],maction[*],mtable[*],mstack[*],math[*],mfrac[*],mfenced[*],mtd[*],mtr[*],mlabeledtr[*],mscarry[*],mstyle[*],mpadded[*],mi[*],mrow[*],ms[*],mtext[*],malignmark[*],maligngroup[*],mglyph[*],mspace[*],' +
      'All[href|id|mathbackground|mathcolor|xlink|href],' +
      'msline[*],mscarries[*],mlongdiv[*],mn[*],menclose[*],msgroup[*],msrow[*],mmultiscripts[*],msub[*],' +
      'div[*],input[*],i[class|title],img[class|src|border=0|alt|title|hspace|vspace|width|height|align|onmouseover|onmouseout|name|aria-describedby|style|onclick]',
    object_resizing: true,
    content_style: 'body:{background-color:#fff;}',
  };

  constructor() {}

  ngOnInit() {}
}
